import React from 'react';
import Navbar from './Navbar';

class Lucky extends React.Component{
    constructor(props){
        super(props);   
        this.state={
            calculating:false,
            calculated:false,
            meter:0,
            color:"red"
        };
        this.calculate = this.calculate.bind(this);
    }
    sleep=(ms)=>{
        return new Promise(resolve => setTimeout(resolve, ms));
      }
    async calculate(){
        this.setState({calculating:true});
        this.setState({calculated:true});
        const res=Math.floor((Math.random() * 100));
        for(let i=0; i<res;i++){
            this.setState({meter:i});
            if(this.state.meter<60){
                this.setState({color:"yellow"});
                if(this.state.meter<30){
                    this.setState({color:"red"});
                }
            }else{
                this.setState({color:"green"});
            }
            await this.sleep(i);
        }
        this.setState({calculating:false});
    }
    render(){
        if(this.state.calculated){      
            return (
                <div className="pusher" style={{backgroundColor:"#1b1c1d"}}>
                <div className="ui inverted vertical masthead center aligned segment">
                <Navbar active="lucky" color="inverted"/>
                <div className="ui text container">
                <img src="/decider/images/luck.svg" alt="Clover" style={{marginTop:"1.1vh",filter:"brightness(1.9)"}} />
                <h1 className="ui inverted header" style={{fontSize:"3em",marginTop:"0"}}>Test Your Luck Here!</h1>
                <div onClick={this.state.calculating ? (e)=>{e.preventDefault()} : this.calculate} className={"ui huge button "+(this.state.calculating ? "disabeled" : "primary")}>{this.state.calculating ? "Calculating..." : "Calculate"}</div>
                <div className={"ui progress "+this.state.color}>
                    <div className="bar" style={{width:Math.floor(this.state.meter)+"%"}}>
                        <div className="progress">{this.state.meter}%</div>
                    </div>
                </div>
                        <div className={"ui huge statistic "+this.state.color} style={{marginBottom:"10.9vh"}}>
                            <div className="label" style={{color:"white"}}>
                                You are
                            </div>
                            <div className="value">
                                {this.state.meter}%
                            </div>
                            <div className="label" style={{color:"white"}}>
                                {this.state.meter < 10 ? "Very Very Unlucky (Becareful!)" : this.state.meter < 30 ? "Very Unlucky" : this.state.meter < 60 ? "Unlucky" : this.state.meter > 80 ? "Very Lucky" : "Lucky"}
                            </div>
                        </div>
                        </div>
                </div>
                </div>
            );
        }else{
            return (
                <div className="pusher" style={{backgroundColor:"#1b1c1d"}}>
                <div className="ui inverted vertical masthead center aligned segment">
                    <Navbar active="lucky" color="inverted" />
                    <div className="ui text container">
                    <img src="/decider/images/luck.svg" alt="Clover" style={{marginTop:"1.1vh",filter:"brightness(1.9)"}} />
                    <h1 className="ui inverted header" style={{fontSize:"3em",marginTop:"0"}}>Test Your Luck Here!</h1>
                    <div onClick={this.state.calculating ? (e)=>{e.preventDefault()} : this.calculate} className={"ui huge button "+(this.state.calculating ? "disabeled" : "primary")}>{this.state.calculating ? "Calculating..." : "Calculate"}</div>
                    <div className="ui progress" style={{margin:"1em 0 35vh"}}>
                        <div className="bar" style={{width:"100%",backgroundColor:"#e8e8e8",textAlign:"center",paddingTop:"0.15em"}}>
                            <div className="ui statistic">
                                <p className="label">
                                    Press Calclulate!
                                </p>
                            </div>
                        </div>
                    </div>
                    <h4 className="ui header inverted" >By: Ihsan Fajar Ramadhan</h4>
                    </div>
                </div>
                </div>
            );
        }
    }
}

export default Lucky;